import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 32px 16px;
  background-color: #ffffff;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 20px;
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
`;

export const StepCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: #f8fafc;
  padding: 16px;
  border-radius: 14px;
  border: 1px solid #f1f5f9;
`;

export const StepNumberCircle = styled.div`
  width: 32px;
  height: 32px;
  background: #8b5cf6;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StepTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
`;

export const StepDesc = styled.div`
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
`;

export const FaqSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FaqTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
  text-align: center;
`;

export const FaqItem = styled.div`
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  padding: 14px;
`;

export const FaqQ = styled.h5`
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 6px 0;
`;

export const FaqA = styled.div`
  font-size: 13px;
  color: #64748b;
  margin: 0;
  line-height: 1.4;
`;
